import { useQuery } from 'react-query';
import FarmerUsersService from '~/api/services/farmerUsers';
import { onError } from '~/utils/helpers';

const getFarmerUsersIndex = (data?) => useQuery(
  'farmer-users-list',
  () => FarmerUsersService.getFarmerUsersIndex(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerUsersListOptions = () => useQuery(
  'farmer-users-list-options',
  FarmerUsersService.getFarmerUsersIndexData,
  {
    onError,
    refetchOnMount: false,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerUsersCount = (data?) => useQuery(
  'farmer-users-count',
  () => FarmerUsersService.getFarmerUsersCount(data),
  {
    onError,
    refetchOnMount: false,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

export const FarmerUsersQuery = {
  getFarmerUsersIndex,
  getFarmerUsersListOptions,
  getFarmerUsersCount
}
